/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Int32CriteriaRangeRequest
 */
export interface Int32CriteriaRangeRequest {
    /**
     * 
     * @type {number}
     * @memberof Int32CriteriaRangeRequest
     */
    from?: number;
    /**
     * 
     * @type {number}
     * @memberof Int32CriteriaRangeRequest
     */
    to?: number;
    /**
     * 
     * @type {boolean}
     * @memberof Int32CriteriaRangeRequest
     */
    exclude?: boolean;
}

export function Int32CriteriaRangeRequestFromJSON(json: any): Int32CriteriaRangeRequest {
    return Int32CriteriaRangeRequestFromJSONTyped(json, false);
}

export function Int32CriteriaRangeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): Int32CriteriaRangeRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'from': !exists(json, 'from') ? undefined : json['from'],
        'to': !exists(json, 'to') ? undefined : json['to'],
        'exclude': !exists(json, 'exclude') ? undefined : json['exclude'],
    };
}

export function Int32CriteriaRangeRequestToJSON(value?: Int32CriteriaRangeRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'from': value.from,
        'to': value.to,
        'exclude': value.exclude,
    };
}


